// src/store/slices/doctorsSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { doctors } from "../../types";

// Initial state for the doctors slice
const initialState: doctors.DoctorsStateType = {
  hospitalsList: {
    isLoading: false,
    data: [],
    error: null,
  },
  doctorsList: {
    isLoading: false,
    data: [],
    error: null,
  },
  addDoctor: {
    isLoading: false,
    data: null,
    error: null,
  },
};

// Define the doctors slice
const doctorsSlice = createSlice({
  name: "doctors",
  initialState,
  reducers: {
    // get hospitals list
    getHospitalsListRequest: (
      state: doctors.DoctorsStateType,
      action: PayloadAction<any>
    ) => {
      state.hospitalsList.isLoading = true;
      state.hospitalsList.data = [];
      state.hospitalsList.error = null;
    },
    getHospitalsListSuccess: (
      state: doctors.DoctorsStateType,
      action: PayloadAction<any>
    ) => {
      state.hospitalsList.isLoading = false;
      state.hospitalsList.data = action.payload;
      state.hospitalsList.error = null;
    },
    getHospitalsListError: (
      state: doctors.DoctorsStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.hospitalsList.isLoading = false;
      state.hospitalsList.data = [];
      state.hospitalsList.error = error;
    },

    // get doctors list
    getDoctorsListRequest: (
      state: doctors.DoctorsStateType,
      action: PayloadAction<any>
    ) => {
      state.doctorsList.isLoading = true;
      state.doctorsList.data = [];
      state.doctorsList.error = null;
    },
    getDoctorsListSuccess: (
      state: doctors.DoctorsStateType,
      action: PayloadAction<any>
    ) => {
      state.doctorsList.isLoading = false;
      state.doctorsList.data = action.payload;
      state.doctorsList.error = null;
    },
    getDoctorsListError: (
      state: doctors.DoctorsStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.doctorsList.isLoading = false;
      state.doctorsList.data = [];
      state.doctorsList.error = error;
    },

    // add doctor
    addDoctorRequest: (
      state: doctors.DoctorsStateType,
      action: PayloadAction<any>
    ) => {
      state.addDoctor.isLoading = true;
      state.addDoctor.data = null;
      state.addDoctor.error = null;
    },
    addDoctorSuccess: (
      state: doctors.DoctorsStateType,
      action: PayloadAction<any>
    ) => {
      state.addDoctor.isLoading = false;
      state.addDoctor.data = action.payload;
      state.addDoctor.error = null;
    },
    addDoctorError: (
      state: doctors.DoctorsStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.addDoctor.isLoading = false;
      state.addDoctor.data = null;
      state.addDoctor.error = error;
    },
    addDoctorReset: (state: doctors.DoctorsStateType) => {
      state.addDoctor.isLoading = false;
      state.addDoctor.data = null;
      state.addDoctor.error = null;
    },
  },
});

// Export actions and reducer
export const {
  // get hospitals list
  getHospitalsListRequest,
  getHospitalsListSuccess,
  getHospitalsListError,

  // get doctors list
  getDoctorsListRequest,
  getDoctorsListSuccess,
  getDoctorsListError,

  // add doctor
  addDoctorRequest,
  addDoctorSuccess,
  addDoctorError,
  addDoctorReset,
} = doctorsSlice.actions;

export default doctorsSlice.reducer;
